<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		mounted() {
			if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
				console.log("跳转到手机")
				location.replace('http://m.zanecon.cn')
			} else {
				
			}
			// this.$session.set('devType', "Windows")
			// let currentDevType = this.$session.get('devType')
			// alert(currentDevType)
			// alert(navigator.userAgent.indexOf(currentDevType))
			// alert(navigator.userAgent)
			// if (navigator.userAgent.indexOf("Linux") == "-1" && navigator.userAgent.indexOf("Windows") == "-1" && navigator.userAgent.indexOf("mac") == "-1" && currentDevType == "Windows") {
			// 		// 当前标识为电脑，但是却在浏览器标识信息里找不到相关自动设备字眼名
			// 	// debugger
			// 	this.autoDev()
			// }
		},
		watch: {
			$route: {
				handler(val, oldval) {
					
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style>
	html,
	body {
		background-color: #fff;
	}

	.text-indent-2em {
		text-indent: 2em;
	}

	body {
		padding: 0;
		margin: 0;
	}

	.acitve {
		color: #EA5B24 !important;
	}

	.activeBlock {
		background-color: #EA5B24 !important;
		opacity: 1 !important;
	}

	a {
		text-decoration: none;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	p {
		margin: 0px;
	}

	.navigation {
		height: 65px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue